/* src/app/stardetails/stardetails.component.scss */
.container {
  display: flex;
  align-items: center;
  padding: 0;
}
.rating-container {
  position: relative;
}
.rating {
  color: #e7711b;
  padding: 0;
  position: absolute;
  z-index: 1;
  display: block;
  top: 0;
  left: 0;
  overflow: hidden;
  height: 22px;
  background-color: orange;
  -webkit-mask-image: url(/assets/img/icons/cb_star_active.svg);
  mask-image: url(/assets/img/icons/cb_star_active.svg);
}
.empty {
  width: 124px;
  height: 22px;
  top: 0;
  background-color: #808080;
  -webkit-mask-image: url(/assets/img/icons/cb_star_inactive.svg);
  mask-image: url(/assets/img/icons/cb_star_inactive.svg);
}
.review-container {
  margin-left: 5px;
}
/*# sourceMappingURL=stardetails.component.css.map */
